import React from "react";
import { Box, Typography } from "@mui/material";
import {
  Info,
  EventNote,
  EventBusy,
  EventAvailable,
  Settings,
} from "@mui/icons-material";

const AdminInfoContent = () => {
  return (
    <div className="info-content" style={{ height: "100%" }}>
      <Typography
        variant="h5"
        sx={{
          color: "#c84653",
          mb: 4,
          display: "flex",
          alignItems: "center",
          fontWeight: 500,
        }}
      >
        <Info sx={{ mr: 1 }} /> Guide d'utilisation
      </Typography>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 500, color: "#444" }}>
          Comment utiliser ce panneau administrateur
        </Typography>

        <Typography paragraph>
          Le calendrier administrateur vous permet de gérer les disponibilités
          et de consulter les réservations pour le domaine. Vous pouvez
          interagir directement avec le calendrier pour effectuer plusieurs
          actions.
        </Typography>

        <Box sx={{ mb: 3, mt: 3 }}>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 500,
              mb: 1,
              display: "flex",
              alignItems: "center",
            }}
          >
            <EventNote
              sx={{
                mr: 1,
                color: "#ff9800",
                fontSize: "1.2rem",
              }}
            />
            Voir les réservations
          </Typography>
          <Typography paragraph>
            Cliquez sur une date réservée (vert) pour voir les détails de la
            réservation, y compris les coordonnées du client et les notes
            spécifiques à la réservation. vous pouvez également modifier le
            statut de la réservation (en attente ou approuvée) à partir de cette
            vue.
            <br /> vous pouvez annuler la réservation si nécessaire.
          </Typography>
        </Box>

        <Box sx={{ mb: 3 }}>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 500,
              mb: 1,
              display: "flex",
              alignItems: "center",
            }}
          >
            <EventBusy sx={{ mr: 1, color: "#888", fontSize: "1.2rem" }} />
            Rendre une date indisponible
          </Typography>
          <Typography paragraph>
            Cliquez sur une date disponible et utilisez l'option "Marquer comme
            indisponible" pour empêcher les réservations pour cette date.
          </Typography>
        </Box>

        <Box sx={{ mb: 3 }}>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 500,
              mb: 1,
              display: "flex",
              alignItems: "center",
            }}
          >
            <EventAvailable
              sx={{
                mr: 1,
                color: "#4caf50",
                fontSize: "1.2rem",
              }}
            />
            Rendre une date disponible
          </Typography>
          <Typography paragraph>
            Cliquez sur une date indisponible (grise) et utilisez l'option
            "Marquer comme disponible" pour permettre les réservations pour
            cette date.
          </Typography>
        </Box>

        <Box sx={{ mb: 3 }}>
          <Box>
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 500,
                mb: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <Settings
                sx={{
                  mr: 1,
                  color: "#ff9800",
                  fontSize: "1.2rem",
                }}
              />
              Gérer les jours de la semaine
            </Typography>
          </Box>

          <Typography paragraph>
            Accéder aux paramètres des jours de la semaine. Vous pourrez activer
            ou désactiver chaque jour avec des interrupteurs et enregistrer vos
            modifications. Les changements s'appliqueront à tous les jours
            correspondants du calendrier.
          </Typography>
        </Box>
      </Box>
      <Typography
        variant="body2"
        sx={{
          mt: "auto",
          fontStyle: "italic",
          color: "#676767",
        }}
      >
        Cliquez sur une date dans le calendrier pour la gérer
      </Typography>
    </div>
  );
};

export default AdminInfoContent;
